// TODO(TIF-21 Phase 1): Remove this file — mock scaffolding for video transcoding pipeline
export function isMockVideoEnabled(): boolean {
  return typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('mockVideo');
}

export const MOCK_VIDEO_URL = 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';
